import config from './config';

function getListenerAclApi(params) {
	return Ajax.get(config.getListenerAcl, params);	
}

function getListenerDetailApi(params) {
	return Ajax.get(config.listenersDetail, params);	
}

function getListenerSniListApi(params) {
	return Ajax.get(config.listenerSniList, params);	
}

function getServerGroupDetailApi(params) {
	return Ajax.get(config.serverGroupDetail, params);	
}

function postListenerPrivateConfigApi(params) {
	return Ajax.post(config.listenerPrivateConfig, params, {
        headers: {
          'Content-Type': 'application/json'
        }
    })	
}

function editListenerAclApi(params) {
	return Ajax.post(config.editListenerAcl, params, {
        headers: {
          'Content-Type': 'application/json'
        }
    })
}
            
export {
	getListenerAclApi,
	getListenerDetailApi,
	getListenerSniListApi,
	getServerGroupDetailApi,
	postListenerPrivateConfigApi,
	editListenerAclApi
};


// WEBPACK FOOTER //
// ./src/api/lb/listener/actions.js